<h1 class="c-h1">{{ 'DOCUMENTS.attestations.title' | translate }}</h1>

<div class="attestations-intro">
  <myabvv-introduction [introduction]="'DOCUMENTS.attestations.download_and_print' | translate"></myabvv-introduction>
</div>

<myabvv-alert [condition]="isDownloading()" [message]="'USER_FEEDBACK.download_progress'" [type]="'success'"></myabvv-alert>
<myabvv-alert [condition]="hasDownloadError()" [message]="'USER_FEEDBACK.download_error'" [type]="'error'"></myabvv-alert>

@if (state$ | async; as state) {
  @if (state.loading) {
    <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
  }

  <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>

  @if (!state.loading && state.data && state.data.monthsWithPayments.length === 0) {
    <div class="info-card-empty">
      <i class="fa fa-inbox info-card-empty__icon"></i>
      <span>{{ 'DOCUMENTS.attestations.no_data' | translate }}</span>
    </div>
  }

  @if (!state.loading && state.data && state.data.monthsWithPayments.length > 0) {
    <section class="c-box attestations-container">
      <p-tabs [(value)]="activeTab" [showNavigators]="false">
        <p-tablist>
          <p-tab [value]="0">
            <span class="tab-label-full">{{ 'DOCUMENTS.attestations.tab_label_chomage' | translate }}</span>
            <span class="tab-label-short">{{ 'DOCUMENTS.attestations.tab_label_chomage_short' | translate }}</span>
          </p-tab>
          <p-tab [value]="1">
            <span class="tab-label-full">{{ 'DOCUMENTS.attestations.tab_label_remuner' | translate }}</span>
            <span class="tab-label-short">{{ 'DOCUMENTS.attestations.tab_label_remuner_short' | translate }}</span>
          </p-tab>
          <p-tab [value]="2">
            <span class="tab-label-full">{{ 'DOCUMENTS.attestations.tab_label_summary' | translate }}</span>
            <span class="tab-label-short">{{ 'DOCUMENTS.attestations.tab_label_summary_short' | translate }}</span>
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <!-- Tab 1: Attestation de chômage -->
          <p-tabpanel [value]="0">
            <div class="attestations-list">
              @if (state.data.LMWP12) {
                <div class="c-download-card"
                     [class.is-disabled]="isDownloading()"
                     role="button" tabindex="0"
                     (click)="downloadAttestationOfUnemployment(state.data.LMWP12.memberInternalKey, state.data.LMWP12.monthUnemployment, state.data.LMWP12.docRegion)"
                     (keyup.enter)="downloadAttestationOfUnemployment(state.data.LMWP12.memberInternalKey, state.data.LMWP12.monthUnemployment, state.data.LMWP12.docRegion)">
                  <div class="c-download-card__icon">
                    <i class="fa fa-file-pdf fa-2x"></i>
                  </div>
                  <div class="c-download-card__content">
                    <span class="c-download-card__date">
                      {{ formatMonth(state.data.LMWP12.monthUnemployment) }} {{ 'CALENDAR.full_month.' + (state.data.LMWP12.monthUnemployment | date:'M') | translate }} {{ formatYear(state.data.LMWP12.monthUnemployment) }}
                    </span>
                    <span class="c-download-card__title">{{ getTranslatedData(state.data.LMWP12.regionName) }}</span>
                  </div>
                  <div class="c-download-card__action">
                    <i class="fa fa-download fa-lg"></i>
                  </div>
                </div>
              } @else {
                <div class="attestations-empty">
                  <p>{{ 'DOCUMENTS.attestations.no_recent_data' | translate }}</p>
                </div>
              }
            </div>
          </p-tabpanel>

          <!-- Tab 2: Attestations des allocations -->
          <p-tabpanel [value]="1">
            <div class="attestations-list">
              @for (m of state.data.monthsWithPayments; track m; let i = $index) {
                <div class="c-download-card"
                     [class.is-disabled]="isDownloading()"
                     role="button" tabindex="0"
                     (click)="downloadAttestationOfUnemploymentIncome(m.memberInternalKey, m.monthUnemployment, m.docRegion)"
                     (keyup.enter)="downloadAttestationOfUnemploymentIncome(m.memberInternalKey, m.monthUnemployment, m.docRegion)">
                  <div class="c-download-card__icon">
                    <i class="fa fa-file-pdf fa-2x"></i>
                  </div>
                  <div class="c-download-card__content">
                    <span class="c-download-card__date">
                      {{ formatMonth(m.monthUnemployment) }} {{ 'CALENDAR.full_month.' + (m.monthUnemployment | date:'M') | translate }} {{ formatYear(m.monthUnemployment) }}
                    </span>
                    <span class="c-download-card__title">{{ getTranslatedData(m.regionName) }}</span>
                  </div>
                  <div class="c-download-card__action">
                    <i class="fa fa-download fa-lg"></i>
                  </div>
                </div>
              }
              @if (state.data.monthsWithPayments.length === 0) {
                <div class="attestations-empty">
                  <p>{{ 'DOCUMENTS.attestations.no_data' | translate }}</p>
                </div>
              }
            </div>
          </p-tabpanel>

          <!-- Tab 3: Relevé des allocations -->
          <p-tabpanel [value]="2">
            <div class="attestations-list">
              @if (state.data.regionalPeriods.length > 0) {
                <!-- Trimestre actuel -->
                @if (state.data.lastTrimesterPeriods.length > 0) {
                  <div class="attestations-section">
                    <h3 class="attestations-section__title">{{ 'DOCUMENTS.attestations.last_trimester' | translate }}</h3>
                    @for (p of state.data.lastTrimesterPeriods; track p; let i = $index) {
                      <div class="c-download-card"
                           [class.is-disabled]="isDownloading()"
                           role="button" tabindex="0"
                           (click)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginLastTrimester, endLastTrimester, p.docRegion)"
                           (keyup.enter)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginLastTrimester, endLastTrimester, p.docRegion)">
                        <div class="c-download-card__icon">
                          <i class="fa fa-file-pdf fa-2x"></i>
                        </div>
                        <div class="c-download-card__content">
                          <span class="c-download-card__date">
                            {{ formatMonth(beginLastTrimester) }} {{ 'CALENDAR.full_month.' + (beginLastTrimester | date:'M') | translate }} {{ formatYear(beginLastTrimester) }}
                            -
                            {{ formatMonth(endLastTrimester) }} {{ 'CALENDAR.full_month.' + (endLastTrimester | date:'M') | translate }} {{ formatYear(endLastTrimester) }}
                          </span>
                          <span class="c-download-card__title">{{ getTranslatedData(p.regionName) }}</span>
                        </div>
                        <div class="c-download-card__action">
                          <i class="fa fa-download fa-lg"></i>
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Année actuelle -->
                @if (state.data.thisYearPeriods.length > 0) {
                  <div class="attestations-section">
                    <h3 class="attestations-section__title">{{ 'DOCUMENTS.attestations.last_year' | translate }}</h3>
                    @for (p of state.data.thisYearPeriods; track p; let i = $index) {
                      <div class="c-download-card"
                           [class.is-disabled]="isDownloading()"
                           role="button" tabindex="0"
                           (click)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginThisYear, endThisYear, p.docRegion)"
                           (keyup.enter)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginThisYear, endThisYear, p.docRegion)">
                        <div class="c-download-card__icon">
                          <i class="fa fa-file-pdf fa-2x"></i>
                        </div>
                        <div class="c-download-card__content">
                          <span class="c-download-card__date">
                            {{ formatMonth(beginThisYear) }} {{ 'CALENDAR.full_month.' + (beginThisYear | date:'M') | translate }} {{ formatYear(beginThisYear) }}
                            -
                            {{ formatMonth(endThisYear) }} {{ 'CALENDAR.full_month.' + (endThisYear | date:'M') | translate }} {{ formatYear(endThisYear) }}
                          </span>
                          <span class="c-download-card__title">{{ getTranslatedData(p.regionName) }}</span>
                        </div>
                        <div class="c-download-card__action">
                          <i class="fa fa-download fa-lg"></i>
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Année précédente -->
                @if (state.data.lastYearPeriods.length > 0) {
                  <div class="attestations-section">
                    <h3 class="attestations-section__title">{{ 'DOCUMENTS.attestations.previous_year' | translate }}</h3>
                    @for (p of state.data.lastYearPeriods; track p; let i = $index) {
                      <div class="c-download-card"
                           [class.is-disabled]="isDownloading()"
                           role="button" tabindex="0"
                           (click)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginLastYear, endLastYear, p.docRegion)"
                           (keyup.enter)="downloadAttestationOfUnemploymentAmountsAndDays(p.memberInternalKey, beginLastYear, endLastYear, p.docRegion)">
                        <div class="c-download-card__icon">
                          <i class="fa fa-file-pdf fa-2x"></i>
                        </div>
                        <div class="c-download-card__content">
                          <span class="c-download-card__date">
                            {{ formatMonth(beginLastYear) }} {{ 'CALENDAR.full_month.' + (beginLastYear | date:'M') | translate }} {{ formatYear(beginLastYear) }}
                            -
                            {{ formatMonth(endLastYear) }} {{ 'CALENDAR.full_month.' + (endLastYear | date:'M') | translate }} {{ formatYear(endLastYear) }}
                          </span>
                          <span class="c-download-card__title">{{ getTranslatedData(p.regionName) }}</span>
                        </div>
                        <div class="c-download-card__action">
                          <i class="fa fa-download fa-lg"></i>
                        </div>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </section>
  }
}
